import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  InputAdornment,
  IconButton,
  Grid2,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { RegSchema } from "../../Utils/Schema";
import {  useMutation, useLazyQuery } from "@apollo/client";
import Loader from "../../Components/Common/Loader";
import { SIGNUP_MUTATION } from "../../Utils/Mutations";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { setUserId, setUserEmail } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import { GET_COUNTRIES } from "../../Utils/Queries";
import MaInput from "../../Components/UI/ma-input";
import useAuthFlow from "../../Hooks/use-auth-flow";

const RegisterEmailForm = () => {
  const [value, setValue] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [response, setResponse] = useState("");
  const [country, setCountryId] = useState("");
  const [flagUrl, setFlagUrl] = useState("");
  const { onClose } = useAuthFlow();
  const [dailCode, setDailCode] = useState(1);
  const [lat, setLatitude] = useState(null);
  const [long, setLongitude] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const handleChange2 = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    getLocation();
    getCountries();
  }, []);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
        },
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const params = new URLSearchParams(window.location.search);
  const referral = params.get("referral");

  useEffect(() => {
    if (referral) {
      setFieldValue("referralCode", referral);
    }
  }, [referral]);

  const [getCountries, { loading, error, data }] = useLazyQuery(GET_COUNTRIES);
  const [signup, { loading: signUpLoad, error: signUpError }] =
    useMutation(SIGNUP_MUTATION);

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      country: "",
      password: "",
      referralCode: "",
    },
    validationSchema: RegSchema,
    onSubmit: () => {
      const { firstName, lastName, email, password, referralCode } = values;
const normalizePhone = (phone) => {
  return phone.replace(/[^\d+]/g, "");
};

      const phone = normalizePhone(phoneNumber);

      const favouriteCategories = [];
      signup({
        variables: {
          firstName: firstName,
          lastName: lastName,
          email: email,
          phone: phone,
          password: password,
          lat: lat ? lat : 0,
          long: long ? long : 0,
          country: country,
          favouriteCategories: favouriteCategories,
          referralCode: referralCode,
        },
      })
        .then((response) => {
          // Handle successful signup
          onClose();
          dispatch(setUserId(response?.data?.signUp?.uuid));
          dispatch(setUserEmail(email));
          navigate("/verify");
        })
        .catch((err) => {
          // Handle signup error
        });
    },
  });
  return (
    <>
      {loading && <Loader />}

      <Box sx={{ mt: 3 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ md: 6, xs: 12 }}>
            <MaInput
              error={errors.firstName}
              helperText={errors.firstName}
              value={values.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
              id="firstName"
              label="First name"
              fullWidth
              placeholder="Enter first name"
            />
          </Grid2>
          <Grid2 size={{ md: 6, xs: 12 }}>
            <MaInput
              label="  Last name"
              fullWidth
              error={errors.lastName}
              helperText={errors.lastName}
              id="lastName"
              value={values.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter last name"
            />
          </Grid2>

          <Grid2 size={{ md: 12, xs: 12 }}>
            <MaInput
              fullWidth
              label="   Email address"
              error={errors.email}
              helperText={errors.email}
              id="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Grid2>

          <Grid2 size={{ md: 6, xs: 12 }}>
            <MaInput
              fullWidth
              label="Phone number"
              phone
              value={phoneNumber}
              onChange={(value) => setPhoneNumber(value)}
            />
          </Grid2>
          <Grid2 size={{ md: 6, xs: 12 }}>
            <MaInput
              value={value}
              onChange={handleChange2}
              fullWidth
              label="Country"
              select
            >
              {data?.getAllCountries?.items.map(
                ({ name, _id, flagUrl, dialingCode }) => (
                  <MenuItem
                    value={name}
                    sx={{ p: 1, display: "flex", alignItems: "center" }}
                    onClick={(e) => {
                      setDailCode(dialingCode);
                      setCountryId(_id);
                    }}
                  >
                    <Typography sx={{ ml: 2, fontSize: "12px" }}>
                      {name}
                    </Typography>
                  </MenuItem>
                ),
              )}
            </MaInput>
          </Grid2>
          <Grid2 size={{ md: 6, xs: 12 }}>
            <MaInput
              fullWidth
              label="Password"
              error={errors.password}
              helperText={errors.password}
              id="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter password"
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOutlinedIcon sx={{ fontSize: "16px" }} />
                      ) : (
                        <VisibilityOffOutlinedIcon sx={{ fontSize: "16px" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid2>
          <Grid2 size={{ md: 6, xs: 12 }}>
            <MaInput
              fullWidth
              label="Referral code (optional)"
              error={errors.referralCode}
              helperText={errors.referralCode}
              id="referralCode"
              value={values.referralCode}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="XXXX-XXXX"
            />
          </Grid2>
        </Grid2>

        {/* <Link to="/verify"> */}
        {signUpError && (
          <div className="mt-3 flex items-center justify-center">
            <span className="text-[#FF465C] text-[13px] font-medium border border-solid w-fit bg-[#FF465C1a] rounded-full border-[#FF465C] px-3 py-1">
              {signUpError.message}
            </span>
          </div>
        )}
        {!signUpLoad && (
          <Button
            onClick={handleSubmit}
            variant="contained"
            fullWidth
            sx={{
              borderRadius: "50px",
              py: 1,
              mt: 5,
              height: "46px",
              bgcolor: "#272727",
              color: "#fff",
            }}
          >
            Sign Up
          </Button>
        )}

        {/* </Link> */}
        {signUpLoad && (
          <>
            <LoadingButton
              fullWidth
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              disabled
              sx={{ borderRadius: "20px", py: 1, mt: 3 }}
            >
              Signing Up
            </LoadingButton>
          </>
        )}
      </Box>
    </>
  );
};

export default RegisterEmailForm;
